import React from "react";
import Gifts from "./navigationShieldComponents/gifts";
import Kids from "./navigationShieldComponents/kids";
import Men from "./navigationShieldComponents/men";
import NewReleases from "./navigationShieldComponents/newReleases";
import Sale from "./navigationShieldComponents/sale";
import Women from "./navigationShieldComponents/women";

import './productsBar.scss';

export default class ProductsBar extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            open: false,
            own: "",
            display: {
                "z-index": "-1"
            }
        }
        this.handleClose=this.handleClose.bind(this);
        this.mouseLeave=this.mouseLeave.bind(this);
    }

    mouseLeave(){
        this.setState({
            open: false,
            own: "",
            backgroundStyle: {
                backgroundColor: "#0000"
            },
            display: {
                "z-index": "-1"
            }
        });
    }

    handleClose(){
        this.setState({
            open: false,
            own: "",
            backgroundStyle: {
                backgroundColor: "#0000"
            },
            display: {
                "z-index": "-1"
            }
        });
    }
    handleOpen(own){
        this.setState({
            open: true,
            own: own,
            backgroundStyle: {
                backgroundColor: "#00000075",
            },
            display:{
                "z-index": "20"
            }
        })
    }

    render(){
        return(
            <>
                <div id="wrap-product-bar" onMouseLeave={this.mouseLeave}>
                    <div id="logo-nike">
                        <a href="/home">
                            <svg className="pre-logo-svg" height="60px" width="60px" fill="#111" viewBox="0 0 69 32">
                                <path d="M68.56 4L18.4 25.36Q12.16 28 7.92 28q-4.8 0-6.96-3.36-1.36-2.16-.8-5.48t2.96-7.08q2-3.04 6.56-8-1.6 2.56-2.24 5.28-1.2 5.12 2.16 7.52Q11.2 18 14 18q2.24 0 5.04-.72z"></path>
                            </svg>
                        </a>
                    </div>
                    <div id="list-products">
                        <div onMouseEnter={()=>this.handleOpen("New Releases")}>New Releases</div>
                        <div onMouseEnter={()=>this.handleOpen("Men")}>Men</div>
                        <div onMouseEnter={()=>this.handleOpen("Women")}>Women</div>
                        <div onMouseEnter={()=>this.handleOpen("Kids")}>Kids</div>
                        <div onMouseEnter={()=>this.handleOpen("Sale")}>Sale</div>
                        <div onMouseEnter={()=>this.handleOpen("Gifts")}>Gifts</div>
                    </div>
                    <div id="find-favorite-bag">
                        <div id="wrap-search">
                            <label htmlFor="product-search">
                                <svg className="pre-search-input-icon" fill="#111" height="24px" width="24px" viewBox="0 0 24 24">
                                    <path d="M21.71 20.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39zM11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7z"></path>
                                </svg>
                            </label>
                            <input type="text" id="product-search" placeholder="Search"></input>
                        </div>
                        <div id="favorite">
                            <a href="/favorite">
                                <svg width="24px" height="24px" fill="#111" viewBox="0 0 24 24">
                                    <path d="M21.11 4a6.6 6.6 0 0 0-4.79-1.92A6.27 6.27 0 0 0 12 3.84 6.57 6.57 0 0 0 2.89 4c-2.8 2.68-2.45 7.3.88 10.76l6.84 6.63A2 2 0 0 0 12 22a2 2 0 0 0 1.37-.54l.2-.19.61-.57c.6-.57 1.42-1.37 2.49-2.41l2.44-2.39 1.09-1.07c3.38-3.55 3.8-8.1.91-10.83zm-2.35 9.4l-.25.24-.8.79-2.44 2.39c-1 1-1.84 1.79-2.44 2.36L12 20l-6.83-6.68c-2.56-2.66-2.86-6-.88-7.92a4.52 4.52 0 0 1 6.4 0l.09.08a2.12 2.12 0 0 1 .32.3l.9.94.9-.94.28-.27.11-.09a4.52 4.52 0 0 1 6.43 0c1.97 1.9 1.67 5.25-.96 7.98z"></path>
                                </svg>
                            </a>
                        </div>
                        <div id="bag">
                            <a href="/bag">
                                <svg width="24px" height="24px" fill="#111" viewBox="0 0 24 24">
                                    <path d="M16 7a1 1 0 0 1-1-1V3H9v3a1 1 0 0 1-2 0V3a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1z"></path><path d="M20 5H4a2 2 0 0 0-2 2v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a2 2 0 0 0-2-2zm0 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7h16z"></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                    {/* navigation shield */}
                    {
                        this.state.open && this.state.own==="New Releases" &&
                        <div className="wrap-navigation-shield"  onMouseLeave={this.handleClose} style={this.state.display}>
                            <NewReleases/>
                        </div>
                    }
                    {
                        this.state.open && this.state.own==="Men" &&
                        <div className="wrap-navigation-shield"  onMouseLeave={this.handleClose} style={this.state.display}>
                            <Men/>
                        </div>
                    }
                    {
                        this.state.open && this.state.own==="Women" &&
                        <div className="wrap-navigation-shield"  onMouseLeave={this.handleClose} style={this.state.display}>
                            <Women/>
                        </div>
                    }
                    {
                        this.state.open && this.state.own==="Kids" &&
                        <div className="wrap-navigation-shield"  onMouseLeave={this.handleClose} style={this.state.display}>
                            <Kids/>
                        </div>
                    }
                    {
                        this.state.open && this.state.own==="Sale" &&
                        <div className="wrap-navigation-shield"  onMouseLeave={this.handleClose} style={this.state.display}>
                            <Sale/>
                        </div>
                    }
                    {
                        this.state.open && this.state.own==="Gifts" &&
                        <div className="wrap-navigation-shield"  onMouseLeave={this.handleClose} style={this.state.display}>
                            <Gifts/>
                        </div>
                    }
                    <div id="background-product-bar" style={this.state.backgroundStyle}></div>
                </div>
            </>
        )
    }
}